import React, { PropsWithChildren } from 'react'
import { normalizeBrand } from '@utils/normalizeBrand'

type ThemeWrapperProps = {
  brand: string
  appId?: string
} & PropsWithChildren

export const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ appId, brand, children }) => {
  return (
    <div id={appId} className="dbtheme-base">
      <div className={`dbtheme-${normalizeBrand(brand)}`}>{children}</div>
    </div>
  )
}
